define('viewmodels/pages/cash/withdraw',[
    'knockout',
    'underscore',
    'viewmodels/pages/cash/ChooseMethodViewModel',
    'viewmodels/pages/cash/CannotWithdrawViewModel',
    'viewmodels/modals/dialogs/ViewModelDialog'
], function (ko, _, ChooseMethodViewModel, CannotWithdrawViewModel, ViewModelDialog) {

    var WithdrawViewModel = function(
        session,
        paymentMethods,
        cashTabs,
        getField,
        withdrawMethodViewModelFactory,
        withdrawModel,
        dialog,
        navigation,
        showError,
        ChoiceAlert,
        PaymentWizard
    ) {
        var self = this;
        var player = session.getAssociatedPlayer();

        this.topBarAction = ko.observable();

        this.confirmForfeitBonusInterceptor = function() {

            if ( player.bonus.isActive() ) {

                var confirmForfeit = new ChoiceAlert(
                    getField('forfeit_bonus_warning_title'),
                    getField('forfeit_bonus_warning_message',
                        {
                            wageringRequirement: ko.filters['€'](player.bonus.wageringRequirement().amount),
                            bonusAmount: ko.filters['€'](player.bonus.balance().amount())
                        }),
                    [
                        { id: 'cancel', text: getField('cancel_withdrawal_button_text'), button: 'grey-lighter' },
                        { id: 'forfeit', text: getField('withdraw_anyway_button_text'), button: 'orange' }
                    ]
                );

                return confirmForfeit.show().then(function(choice) {

                    if (choice === 'cancel') {

                        navigation.navigate(navigation.ROUTES.GAMES);
                        return false;
                    }

                    return true;
                });
            }

            return true;
        };

        var withdrawMethodViewModel = withdrawMethodViewModelFactory(
            withdrawModel,
            _.partial(
                PaymentWizard,
                navigation,
                navigation.ROUTES.WITHDRAW_SUCCESS,
                navigation.ROUTES.WITHDRAW_FAILURE,
                getField,
                withdrawModel,
                this.topBarAction,
                this.confirmForfeitBonusInterceptor,
                showError
            )
        );

        self.subNav = cashTabs;

        self.meta = {
            title: getField('meta_title'),
            description: getField('meta_description')
        };

        var methods = ko.pureComputedArray(function () {

            var savedMethods = player.payments.usableWithdrawMethods(),
                availableMethods = _.filter(paymentMethods.availableMethodsForWithdrawWithoutDeposit(), function(method) {
                    return player.payments.canCreateMoreUsableMethodInstancesOfType(method.type)();
                });

            return savedMethods.concat(
                availableMethods.map(function(availableMethod) {
                    return player.payments.makeNewUsableMethod(availableMethod);
                })
            );
        });

        var chooseWithdrawMethodViewModel = new ChooseMethodViewModel(
            'views/pages/cash/chooseMethod.html',
            methods,
            withdrawModel.playerPaymentMethod,
            function() {
                // delaying here so we let the underlying payment method view to render before we close the dialog
                _.delay(chooseMethodDialog.close.bind(chooseMethodDialog), 100);
            }
        );

        var chooseMethodDialog = new ViewModelDialog(dialog, chooseWithdrawMethodViewModel, getField('choose_method_dialog_title'));

        var cannotWithdrawViewModel = new CannotWithdrawViewModel(withdrawModel, getField, player);

        this.selectedPaymentMethodName = ko.pureComputed(function () {

            var playerPaymentMethod = withdrawModel.playerPaymentMethod();

            if (playerPaymentMethod) {
                return playerPaymentMethod.identifier() || playerPaymentMethod.name();
            }

        });

        this.selectedPaymentMethodImage = ko.pureComputed(function () {

            var playerPaymentMethod = withdrawModel.playerPaymentMethod();

            if (playerPaymentMethod) {
                return playerPaymentMethod.specificMethod().imageUrl();
            }

        });

        this.chooseMethod = function() {
            chooseMethodDialog.show();
        };

        self.activeViewModel = ko.pureComputed(function () {

            if (!withdrawModel.playerPaymentMethod().canWithdraw()) {

                return cannotWithdrawViewModel;
            }

            return withdrawMethodViewModel();
        });

        self.activate = function() {
            // always preselect the first withdrawal method
            withdrawModel.playerPaymentMethod(_.first(methods()));
        };

        self.canActivate = function() {
            return paymentMethods.load(true).then(function(result) {
                return result === 'LOADED';
            });
        };

        this.onSuccess = function(routeInfo) {
            withdrawModel.notifySuccessfulReturn(routeInfo.queryParams.data);
            return navigation.reverseRoute( navigation.ROUTES.GAMES_TOP );
        };

        this.onFailure = function() {
            // @todo dhowlett Show an overlay?
            return navigation.reverseRoute( navigation.ROUTES.WITHDRAW );
        };
    };

    return WithdrawViewModel;
});

